import { useQuotaStatus } from '@sazeo/sdk';
import { X } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useRouteLoaderData } from 'react-router-dom';

import type { RootLoaderData } from '../App';
import { tenantSdkClient } from '../lib/sdk';

export function QuotaBanner() {
  const data = useRouteLoaderData('root') as RootLoaderData | undefined;
  const tenantId = data?.tenant.id ?? '';
  const { t } = useTranslation('core.billing');
  const [dismissed, setDismissed] = useState(false);

  const { data: quota } = useQuotaStatus(tenantSdkClient, tenantId);

  if (!quota || (!quota.nearLimit && !quota.overLimit)) return null;
  if (dismissed && !quota.overLimit) return null;

  const isBlocked = quota.overLimit;

  return (
    <div
      role="alert"
      style={{
        backgroundColor: isBlocked ? 'var(--color-error)' : 'var(--color-warning)',
        color: isBlocked ? '#fff' : 'var(--color-bg)',
      }}
      className="flex items-center justify-between gap-3 px-4 py-2 text-[13px] shrink-0"
    >
      <span>
        {isBlocked
          ? t('quota_blocked')
          : t('quota_warning', {
              current: quota.users.current,
              limit: quota.users.limit,
            })}
      </span>
      <div className="flex items-center gap-3 shrink-0">
        <Link
          to="/settings/billing"
          className="underline underline-offset-2 font-medium hover:opacity-80"
        >
          {t('quota_upgrade')}
        </Link>
        {!isBlocked && (
          <button
            type="button"
            aria-label={t('quota_dismiss')}
            onClick={() => setDismissed(true)}
            className="inline-flex items-center justify-center rounded hover:opacity-80"
          >
            <X size={14} />
          </button>
        )}
      </div>
    </div>
  );
}
